import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { get } from '../../../lib/api';

export const fetchTileData = createAsyncThunk(
  'tileForm/fetchTileData',
  async ({ tileId }) => {
    const response = await get(`/api/v1/tiles/${tileId}`);

    return response;
  },
);

const tileFormSlice = createSlice({
  name: 'tileForm',
  initialState: { showTileForm: false },
  reducers: {
    openForm() {
      return {
        showTileForm: true,
      };
    },
    closeForm() {
      return {
        showTileForm: false,
      };
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchTileData.fulfilled, (_, action) => {
      return {
        tile: action.payload,
        showTileForm: true,
      };
    });
  },
});

export const { openForm, closeForm } = tileFormSlice.actions;
export default tileFormSlice.reducer;
